import { render } from "./contact.vue?vue&type=template&id=5cabf785&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=5cabf785&scoped=true&lang=css"
import "./contact.vue?vue&type=style&index=1&id=5cabf785&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cabf785"]])

export default __exports__